import script from "./LiveData.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveData.vue?vue&type=script&setup=true&lang=js"

import "./LiveData.vue?vue&type=style&index=0&id=4346e824&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4346e824"]])

export default __exports__